import { Component, Inject, NgZone } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { map } from 'rxjs';
import { defaultCancelReasons } from 'server/helpers/defaultCancelReasons';
import { CancelReason } from 'server/shared/models/cancelReason';
import { InpoolLanguage } from 'server/shared/models/InpoolLanguage';
import { CustomerService } from 'src/app/services/customer.service';
import { TranslationService } from '../../../../services/translation.service';

export interface DialogData {
  reasons: CancelReason[];
  forceReason?: CancelReason;
  additionalWarning?: string;
}

@Component({
  selector: 'cancel-invitee-dialog',
  templateUrl: 'cancel-dialog.html',
  styleUrls: ['./cancel-dialog.component.scss'],
})
export class CancelDialog {
  lang: InpoolLanguage = this.translationService.getLanguage();
  reason?: CancelReason;
  reasonDescription?: string;
  informInviteeOfReason: boolean = true;

  dispoCustomer$ = this.customerService.readyDispoCustomer$;
  cancelReasons$ = this.dispoCustomer$.pipe(
    map((customer) => customer?.cancelReasons || defaultCancelReasons),
  );

  constructor(
    public dialogRef: MatDialogRef<CancelDialog>,
    private translationService: TranslationService,
    private ngZone: NgZone,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private customerService: CustomerService,
  ) {
    if (this.data?.forceReason) {
      this.reason = this.data.forceReason;
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
